import type { ComponentProps } from "react"
import { Box } from "~/components/legacy/common/box"
import { inputVariants } from "~/components/legacy/common/input"
import { cx, type VariantProps } from "~/lib/legacy-utils"

export type TextAreaProps = Omit<ComponentProps<"textarea">, "size"> &
  VariantProps<typeof inputVariants>

export const TextArea = ({ className, size, ...props }: TextAreaProps) => {
  return (
    <Box focus>
      <textarea
        className={cx(
          inputVariants({ size, className }),
          "leading-normal! resize-none field-sizing-content",
        )}
        {...props}
      />
    </Box>
  )
}
